import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'scroll-to': 'scroll', } };
        this.goUp = this.$('go-up')[0];
    }
    init() {

        this.goUp.addEventListener( 'click', (e) => {
            this.call('scrollTo', { target : document.querySelector('[data-top]'), options: { offset: -100 } },  'Scroll');
        });

    }
    destroy(){}
}
